import { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { sessionStore } from '~atoms/sessionAtom';
import pagePaths from '~constants/pagePaths';
import { GeneralLoaderWrapper } from '~layouts';

const LogoutPage = () => {
	const { t } = useTranslation('auth');
	const navigate = useNavigate();
	const hasTriggeredSignoutRef = useRef(false);

	useEffect(() => {
		if (hasTriggeredSignoutRef.current) {
			return;
		}
		hasTriggeredSignoutRef.current = true;

		const notifyProviderLogout = async () => {
			// Not sure if this is really needed, but we would have to find the endpoint.
			// try {
			// 	const endSessionEndpoint = await userManager.metadataService.getEndSessionEndpoint();
			// 	if (!endSessionEndpoint) {
			// 		return;
			// 	}
			// 	const logoutUrl = new URL(endSessionEndpoint);
			// 	const postLogoutUrl = new URL(pagePaths.AuthLogin, window.location.origin).href;
			// 	if (user?.id_token) {
			// 		logoutUrl.searchParams.set('id_token_hint', user.id_token);
			// 	}
			// 	logoutUrl.searchParams.set('post_logout_redirect_uri', postLogoutUrl);
			// 	if (import.meta.env.VITE_SKOPEI_OIDC_CLIENT_ID) {
			// 		logoutUrl.searchParams.set('client_id', import.meta.env.VITE_SKOPEI_OIDC_CLIENT_ID);
			// 	}
			// 	void fetch(logoutUrl.toString(), {
			// 		method: 'GET',
			// 		mode: 'no-cors',
			// 		credentials: 'include',
			// 	}).catch(() => {
			// 		// The provider might still block the request; that's fine for our purposes.
			// 	});
			// } catch (error) {
			// 	console.warn('[Auth] Unable to notify identity provider about logout', error);
			// }
		};

		const signout = async () => {
			try {
				await notifyProviderLogout();
			} finally {
				console.info('[Auth] Signed out from signout page');

				sessionStore.clear();
				navigate(pagePaths.AuthLogin, { replace: true });
			}
		};

		void signout();
	}, [navigate]);

	return <GeneralLoaderWrapper title={t('signingOut')} />;
};

export default LogoutPage;
